import type { ListProjectBrands } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

export function useResolveBrands(projectIds: number[] | undefined) {
  return useQuery({
    enabled: projectIds && projectIds.length > 0,
    queryFn: () =>
      apiClient
        .url("/users/resolve-brands")
        .post({ projectIds })
        .json<ListProjectBrands>(),
    queryKey: ["user-list-brands", projectIds],
  });
}
